export const WORKER_TIER_FETCH_BEGIN = 'syftacp/WORKER_TIER_FETCH_BEGIN'
export const WORKER_TIER_FETCH_FAILED = 'syftacp/WORKER_TIER_FETCH_FAILED'
export const WORKER_TIER_FETCH_SUCCEEDED = 'syftacp/WORKER_TIER_FETCH_SUCCEEDED'
